/** Formula to calculate a progress bar percent */

export const getProgressPercent = (
  currentStep: number,
  totalSteps: number,
): number => {
  return (currentStep / totalSteps) * 100;
};

export default getProgressPercent;
